export const podcast = {
    labels: {
        podcast: "Podcast",
        podcasts: "Podcasts",
        title: "Título",
        subtitle: "Subtítulo",
        episode: "Episodio",
        duration: "Duração",
        author: "Autor",
        explicit: "Explícito",
        summary: "Sumário",
        keywords: "Palavras-chave",
        code: "Código",
        description: "Descrição",
        edit_podcast: "Editar Podcast",
        name: "Nome",
        slug: "Slug",
    },
    placeholders: {
        description: "Informe a descrição",
        name: "Informe o nome",
        slug: "Exe: nome-da-url",
    },
    modals: {
        titles: {
            add_podcast: "Adicionar Podcast",
            edit_podcast: "Editar Podcast",
            del_podcast: "Excluir Podcast",
        },
        messages: {
            del_podcast: "Você deseja mesmo excluir o podcast <strong>{name}</strong>?<br/>Todos os relacionamentos deste podcast serão excluídos.",
        },
    },
    texts: {
    },
};
